import React from 'react';

type MainProps = {
  onAgree: () => void;
}
const Main: React.FC<MainProps> = ({ onAgree }) => {
  return (
    <React.Fragment>
      <main className="wrapper">
        <div className="sec-posts">
          <div className="inner">
          <h1 className="c-ttl__01 mbpc-60 mbsp-30">医療従事者向け情報</h1>
          <div>
            <p className="c-txt__01 c-txt__lh18 c-al--c mbpc-30 mbsp-30">
              医療従事者向け情報ページは、
              <br className="sp" />
              当社の医療機器に関する情報を、
              <br />
              医療従事者の方へ提供することを
              <br className="sp" />
              目的として作成しております。
              <br />
              一般の方への情報提供を目的とした
              <br className="sp" />
              ものではありませんので、<br className="sp" />
              あらかじめご了承ください。
            </p>
            <h2 className="c-ttl__02 c-al--c mbpc-30 mbsp-30">あなたは医療従事者ですか？</h2>
            <button type="submit" className="c-btn__01" onClick={onAgree}>はい</button>
            <div className="c-al--c">
              <a className="c-btn__02" target="_blank" rel="noopener noreferrer" href="https://www.seed.co.jp/products/contact/orthokeratology.html">いいえ</a>
            </div>
          </div>
          </div>
        </div>
      </main>
    </React.Fragment>
  );
};

export default Main;